import React from 'react'
import Breadcrumb from '../components/Breadcrumb';
import ClientByID from '../components/ClientByID';

const ClientByIDPage = () => {
  return (
    <>
      {/* Breadcrumb */}
      <Breadcrumb title="View Client" />

      {/*All Clients Layer*/}
      <ClientByID />
    </>
  );
}

export default ClientByIDPage